import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { CircularProgress, SxProps, Theme, Stack, ButtonBase } from '@mui/material';

import { intl } from '@ocx-app/lib/translation/TranslationProvider';
import { SizingMultiplier, Typography } from '@ocx/ui';

import { BUTTON_HEIGHT } from '../local-offers.constants';
import { locationSelectorMessages } from './location-selector.messages';
import { LocalOffersLocationState } from '../local-offers.types';

export type LocationSelectorProps = {
  onClick?: () => void;
  locationState: LocalOffersLocationState;
  customLocationName?: string;
  sx?: SxProps<Theme>;
};

const ICON_SIZE = 20;
const CIRCULAR_PROGRESS_SIZE = 16;
const VERTICAL_SPACING = 0.75;

export const LocationSelector = ({ onClick, locationState, customLocationName, sx }: LocationSelectorProps) => {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        height: BUTTON_HEIGHT,
        borderRadius: BUTTON_HEIGHT / 2,
        py: VERTICAL_SPACING,
        px: SizingMultiplier.sm,
        backgroundColor: (theme) => theme.palette.primary.main,
        color: (theme) => theme.palette.common.white,
        whiteSpace: 'nowrap',
        ...sx,
      }}>
      <Stack direction="row" alignItems="center">
        {locationState === 'fetching' && (
          <>
            <CircularProgress size={CIRCULAR_PROGRESS_SIZE} color="inherit" sx={{ marginRight: SizingMultiplier.xs }} />
            <Typography variant="body2">
              {intl.formatMessage(locationSelectorMessages['locationSelector:fetchingYourLocationLabel'])}
            </Typography>
          </>
        )}

        {locationState !== 'fetching' && (
          <>
            <LocationOnOutlinedIcon sx={{ marginRight: 0.25, width: ICON_SIZE, height: ICON_SIZE }} />
            <Typography variant="body2" noWrap>
              {locationState === 'nearby' &&
                intl.formatMessage(locationSelectorMessages['locationSelector:nearbyLabel'])}
              {locationState === 'custom' && customLocationName}
              {locationState === 'all' && intl.formatMessage(locationSelectorMessages['locationSelector:allLabel'])}
            </Typography>
            <ArrowDropDownIcon sx={{ width: ICON_SIZE, height: ICON_SIZE }} />
          </>
        )}
      </Stack>
    </ButtonBase>
  );
};
